import type { Role } from '@timato/shared';
const RANK: Record<Role, number> = { member: 0, admin: 1, owner: 2 };
export const hasRole = (role: Role, atLeast: Role) => RANK[role] >= RANK[atLeast];
export const ROLE_LABEL: Record<Role, string> = { owner: 'Owner', admin: 'Admin', member: 'Member' };
